module.exports = __webpack_public_path__ + "static/Venezuela-c38f98ed147b4277bb2df48dfaf925d0.png";